import React from "react";
import { Link } from "react-router-dom";
import { Info, CalendarPlus, FileUp } from "lucide-react";

// Discreet reminder: availability is computed from connected calendars only.
export default function CoverageBanner({ coverage, onAddEvent }) {
  if (!coverage || coverage.complete) return null;
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-xl border border-border bg-card/60 px-4 py-2.5 text-xs text-muted-foreground" data-testid="coverage-banner">
      <Info className="w-3.5 h-3.5 text-amber-400 shrink-0" />
      <span className="flex-1 min-w-[200px]">Apple Calendar non connecté — la disponibilité peut être incomplète. Les créneaux « libres » le sont <em>selon les calendriers connectés</em>.</span>
      <button data-testid="coverage-add-event" onClick={onAddEvent} className="inline-flex items-center gap-1.5 rounded-full border border-border px-3 py-1 hover:bg-accent text-foreground"><CalendarPlus className="w-3.5 h-3.5" /> Ajouter un événement</button>
      <Link data-testid="coverage-import-ics" to="/settings#calendars" className="inline-flex items-center gap-1.5 rounded-full border border-border px-3 py-1 hover:bg-accent text-foreground"><FileUp className="w-3.5 h-3.5" /> Importer un .ics</Link>
    </div>
  );
}
